import operations from '~/helpers/device-operations';
import { fwPrivate } from '~/helpers/fields-description';
import { rfStatus } from '~/helpers/network-fields-description';
import { Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';
export class BNS extends Gateway {

    loadData(data: any) {
        super.loadData(data);
        this.loadHeatingAlgo(data.heating_algo);
    }

    get fieldFwPrivate(): FieldObject | undefined {
        return fwPrivate(this.firmware_private);
    }

    getNetworkFields(): FieldObject[] {
        let fields: FieldObject[] = [];
        if (this.network) {
            fields = super.getNetworkFields();
            if (this.network.rf_amb_status) {
                fields.push(rfStatus(this.getRfIcon(this.network.rf_amb_status), this.network.rf_amb_status));
            }
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }
        return fields;
    }

    get deviceOperations(): Operation[]  {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
        ]);
    }

}

